// export default Header;
import React, { useContext } from "react";
import { Link } from "react-router-dom";
import LogoutLink from "./Logout";
import { Dropdown } from "react-bootstrap";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

/// Image
import profile from "../../../assets/images/profile/12.png";
import { ThemeContext } from "../../../context/ThemeContext.jsx";

const Header = ({ user }) => {
   // const { background, changeBackground } = useContext(ThemeContext);
   const location = useLocation();
   const pathname = location.pathname;
   const patientFromRedux = useSelector(state => state.patients?.patientDetails);
   const leadDetails = useSelector((state) => state.leadState?.leadDetails);
   const casePaperData = useSelector(state => state.casePaper?.casePaperData);

   const roleNameFromState = location?.state?.role?.role_name;
   const userNameFromState = location?.state?.user?.admin_name;
   const questionTitleFromState = location?.state?.question?.Question;
   const formTitleFromState = location?.state?.form?.form_title;
   const branchNameFromState = location?.state?.branch?.branch_name;
   const departmentNameFromState = location?.state?.department?.department_name;
   const categoryNameFromState = location?.state?.category?.category_name;
   const symptomNameFromState = location?.state?.symptom?.symptom_name;
   const diseaseNameFromState = location?.state?.disease?.disease_name;
   const medicineNameFromState = location?.state?.medicine?.medicine_name;
   const doctorNameFromState = location?.state?.doctor?.doctor_name;
   // const patientNameFromState =
   //    location?.state?.patients?.first_name && location?.state?.patients?.last_name
   //       ? `${location.state.patients.first_name} ${location.state.patients.last_name}`
   //       : patientFromRedux?.first_name && patientFromRedux?.last_name
   //          ? `${patientFromRedux.first_name} ${patientFromRedux.last_name}`
   //          : null;
   const patientNameFromState = (() => {

      function calculateAge(dob) {
         if (!dob || dob === "0000-00-00") return "";
         const birthDate = new Date(dob);
         if (isNaN(birthDate)) return "";

         const today = new Date();
         let age = today.getFullYear() - birthDate.getFullYear();

         const m = today.getMonth() - birthDate.getMonth();
         const d = today.getDate() - birthDate.getDate();

         if (m < 0 || (m === 0 && d < 0)) age--;

         return age > 0 ? `${age} years` : "";
      }

      function convertHeight(cmValue) {
         const cm = Number(cmValue);
         if (!cm || cm <= 0) return "";

         const totalInches = cm / 2.54;
         const feet = Math.floor(totalInches / 12);
         const inches = Math.round(totalInches % 12);

         return `${feet}ft ${inches}in`;
      }

      // Remove weeks (w)
      function cleanMarriageAge(ageStr = "") {
         return ageStr.replace(/,\s*\d+\s*w/gi, "").trim();
      }

      const p = location?.state?.patients || patientFromRedux;
      if (!p) return null;

      const fullName =
         p.first_name && p.last_name
            ? `${p.first_name} ${p.last_name}`
            : p.first_name || "";

      const info = [];

      // 1) AGE
      const age = calculateAge(p.date_of_birth);
      if (age) info.push(age);

      // 2) WEIGHT
      if (Number(p.weight) > 0) {
         info.push(`${p.weight}Kg`);
      }

      // 3) HEIGHT
      const heightFt = convertHeight(p.height);
      if (heightFt) info.push(heightFt);

      // 4) PROFESSION
      if (p.occupation && p.occupation.trim() !== "") {
         info.push(p.occupation);
      }

      // 5) MARRIAGE AGE
      const latestMarriage = p.marriageInfo?.[0];
      let marriageAge = latestMarriage?.marriage_age;

      if (marriageAge && marriageAge.trim() !== "" && marriageAge !== "0") {
         marriageAge = cleanMarriageAge(marriageAge);
         if (marriageAge) info.push(marriageAge);
      }
      // 6) CURRENT DISEASE (show only disease_name)
      const rawDisease = p.currentDiseases;

      if (rawDisease) {
         let diseaseStr = "";

         if (Array.isArray(rawDisease)) {
            // Array → extract disease_name from each object
            diseaseStr = rawDisease
               .map((d) => d?.disease_name)
               .filter(Boolean)
               .join(", ");
         } else if (typeof rawDisease === "object") {
            // Object → use only disease_name
            diseaseStr = rawDisease?.disease_name || "";
         } else {
            // Fallback → convert to string
            diseaseStr = String(rawDisease);
         }

         if (diseaseStr.trim() !== "") {
            info.push(diseaseStr.trim());
         }
      }

      // FINAL FORMAT: Name (all info)
      // return `${fullName}${info.length > 0 ? ` (${info.join(" / ")})` : ""}`;
      return (
         <>
            <strong>{fullName}</strong>
            {info.length > 0 && (
               <span> ({info.join(" / ")})</span>
            )}
         </>
      );

   })();

   const casePaperPatientName = (() => {

      function calculateAge(dob) {
         if (!dob || dob === "0000-00-00") return "";
         const birthDate = new Date(dob);
         if (isNaN(birthDate)) return "";
         const today = new Date();
         let age = today.getFullYear() - birthDate.getFullYear();
         const m = today.getMonth() - birthDate.getMonth();
         const d = today.getDate() - birthDate.getDate();
         if (m < 0 || (m === 0 && d < 0)) age--;
         return age > 0 ? `${age} years` : "";
      }

      function convertHeight(cmValue) {
         const cm = Number(cmValue);
         if (!cm || cm <= 0) return "";
         const totalInches = cm / 2.54;
         const feet = Math.floor(totalInches / 12);
         const inches = Math.round(totalInches % 12);
         return `${feet}ft ${inches}in`;
      }

      const p = casePaperData?.patient;
      if (!p) return null;

      const fullName =
         p.first_name && p.last_name
            ? `${p.first_name} ${p.last_name}`
            : p.first_name || "";

      const info = [];

      const age = calculateAge(p.date_of_birth);
      if (age) info.push(age);

      if (Number(p.weight) > 0) info.push(`${p.weight}Kg`);

      const heightFt = convertHeight(p.height);
      if (heightFt) info.push(heightFt);

      if (p.occupation && p.occupation.trim() !== "") info.push(p.occupation);


      const rawDisease = p.currentDiseases || p.diseases;

      if (rawDisease) {
         let diseaseStr = "";

         if (Array.isArray(rawDisease)) {
            diseaseStr = rawDisease
               .map((d) => d?.disease_name)
               .filter(Boolean)
               .join(", ");
         } else if (typeof rawDisease === "object") {
            diseaseStr = rawDisease?.disease_name || "";
         } else {
            diseaseStr = String(rawDisease);
         }

         if (diseaseStr.trim() !== "") {
            info.push(diseaseStr.trim());
         }
      }

      return (
         <>
            <strong>{fullName}</strong>
            {info.length > 0 && <span> ({info.join(" / ")})</span>}
         </>
      );
   })();


   const leadNameFromRedux =
      leadDetails?.first_name && leadDetails?.last_name
         ? `${leadDetails.first_name} ${leadDetails.last_name}`
         : leadDetails?.first_name
            ? leadDetails.first_name
            : leadDetails?.last_name
               ? leadDetails.last_name
               : null;

   var path = window.location.pathname.split("/");
   //console.log("path:", path);
   var name = path[path.length - 1].split("-");
   //console.log("name", name);
   var filterName = name.length >= 3 ? name.filter((n, i) => i > 0) : name;
   //console.log("filtername:", filterName);

   var finalName = filterName.includes("app")
      ? filterName.filter((f) => f !== "app")
      : filterName.includes("ui")
         ? filterName.filter((f) => f !== "ui")
         : filterName.includes("uc")
            ? filterName.filter((f) => f !== "uc")
            : filterName.includes("basic")
               ? filterName.filter((f) => f !== "basic")
               : filterName.includes("form")
                  ? filterName.filter((f) => f !== "form")
                  : filterName.includes("table")
                     ? filterName.filter((f) => f !== "table")
                     : filterName.includes("page")
                        ? filterName.filter((f) => f !== "page")
                        : filterName.includes("email")
                           ? filterName.filter((f) => f !== "email")
                           : filterName.includes("ecom")
                              ? filterName.filter((f) => f !== "ecom")
                              : filterName.includes("chart")
                                 ? filterName.filter((f) => f !== "chart")
                                 : filterName.includes("editor")
                                    ? filterName.filter((f) => f !== "editor")
                                    : filterName;

   // const adminName = user?.admin_name || "Admin";
   // const adminEmail = user?.admin_email || "";
   const profileData = useSelector(state => state.profile?.profile);

   const adminName = profileData?.name || user?.admin_name || "Admin";
   const adminEmail = profileData?.email || user?.admin_email || "";
   return (
      <div className="header">
         <div className="header-content">
            <nav className="navbar navbar-expand">
               <div className="collapse navbar-collapse justify-content-between">
                  <div className="header-left">
                     <div className="dashboard_bar" style={{ textTransform: "capitalize" }}>
                        {[
                           "/telecaller",
                           "/receptionist",
                           "/doctor",
                           "/counsellor",
                           "/medical",
                           "/service-caller",
                        ].includes(pathname)
                           ? user?.role_name?.toLowerCase() === "admin"
                              ? `Dashboard / ${pathname.slice(1).charAt(0).toUpperCase() + pathname.slice(2)}`
                              : "Dashboard"
                           : pathname === "/disease-medicine-mapping"
                              ? "Disease Medicine Mapping"
                              : pathname.includes("/edit-role") && roleNameFromState
                                 ? `${roleNameFromState}`
                                 : pathname.includes("/edit-user") && userNameFromState
                                    ? `${userNameFromState}`
                                    : pathname.includes("/edit-question") && questionTitleFromState
                                       ? `${questionTitleFromState}`
                                       : pathname.includes("/forms/edit-form") && formTitleFromState
                                          ? `${formTitleFromState}`
                                          : pathname.includes("/update-branch") && branchNameFromState
                                             ? `${branchNameFromState}`
                                             : pathname.includes("/update-department") && departmentNameFromState
                                                ? `${departmentNameFromState}`
                                                : pathname.includes("/update-category") && categoryNameFromState
                                                   ? `${categoryNameFromState}`
                                                   : pathname.includes("/update-symptom") && symptomNameFromState
                                                      ? `${symptomNameFromState}`
                                                      : pathname.includes("/update-diseases") && diseaseNameFromState
                                                         ? `${diseaseNameFromState}`
                                                         : pathname.includes("/update-medicine") && medicineNameFromState
                                                            ? `${medicineNameFromState}`
                                                            : pathname.includes("/update-doctor") && doctorNameFromState
                                                               ? `${doctorNameFromState}`
                                                               : pathname.includes("patient-details") && patientNameFromState
                                                                  ? patientNameFromState
                                                                  : pathname.includes("/case-paper") && casePaperPatientName
                                                                     ? <span className="cp-title" style={{ textAlign: "left", marginLeft: "100px" }}>{casePaperPatientName}</span>



                                                                     : pathname.includes("update-patient") && patientNameFromState
                                                                        ? patientNameFromState
                                                                        : pathname.includes("/app-update-lead") && leadNameFromRedux
                                                                           ? `${leadNameFromRedux}`
                                                                           : pathname.includes("/app-lead-details") && leadNameFromRedux
                                                                              ? `${leadNameFromRedux}`
                                                                              : pathname.includes("/add-campaign") && location?.state?.item
                                                                                 ? location.state.item.title
                                                                                 : finalName.join(" ") || "Dashboard"}
                     </div>


                  </div>
                  {/* <ul className="navbar-nav header-right">
                     <Dropdown as="li" className="nav-item header-profile">
                        <Dropdown.Toggle className="nav-link i-false" as="a">
                           <img src={profile} width={20} alt="profile" />
                           <div className="header-info">
                              <span>
                                 Hello,<strong> {adminName}</strong>
                              </span>
                              {adminEmail && (
                                 <small style={{ fontSize: "0.8rem", display: "block", color: "#888" }}>
                                    {adminEmail}
                                 </small>
                              )}
                           </div>
                        </Dropdown.Toggle>

                        <Dropdown.Menu align="end" className="dropdown-menu-right">
                           <Link to="/app-profile" className="dropdown-item ai-icon">
                              <svg
                                 xmlns="http://www.w3.org/2000/svg"
                                 className="text-primary"
                                 width={18}
                                 height={18}
                                 viewBox="0 0 24 24"
                                 fill="none"
                                 stroke="currentColor"
                                 strokeWidth={2}
                                 strokeLinecap="round"
                                 strokeLinejoin="round"
                              >
                                 <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                                 <circle cx={12} cy={7} r={4} />
                              </svg>
                              <span className="ms-2">Profile</span>
                           </Link>
                           <Link to="/app-change-password" className="dropdown-item ai-icon">
                              <svg
                                 xmlns="http://www.w3.org/2000/svg"
                                 className="text-success"
                                 width={18}
                                 height={18}
                                 viewBox="0 0 24 24"
                                 fill="none"
                                 stroke="currentColor"
                                 strokeWidth={2}
                                 strokeLinecap="round"
                                 strokeLinejoin="round"
                              >
                                 <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                                 <polyline points="22,6 12,13 2,6" />
                              </svg>
                              <span className="ms-2">Change Password</span>
                           </Link>
                           <LogoutLink />
                        </Dropdown.Menu>
                     </Dropdown>
                  </ul> */}
                  {/* Hide profile dropdown ONLY on case-paper */}
                  {!pathname.includes("/case-paper") && (
                     <ul className="navbar-nav header-right">
                        <Dropdown as="li" className="nav-item header-profile">
                           <Dropdown.Toggle className="nav-link i-false" as="a">
                              <img src={profile} width={20} alt="profile" />
                              <div className="header-info">
                                 <span>
                                    Hello,<strong> {adminName}</strong>
                                 </span>
                                 {adminEmail && (
                                    <small style={{ fontSize: "0.8rem", display: "block", color: "#888" }}>
                                       {adminEmail}
                                    </small>
                                 )}
                              </div>
                           </Dropdown.Toggle>

                           <Dropdown.Menu align="end" className="dropdown-menu-right">
                              <Link to="/app-profile" className="dropdown-item ai-icon">
                                 <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="text-primary"
                                    width={18}
                                    height={18}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                 >
                                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                                    <circle cx={12} cy={7} r={4} />
                                 </svg>
                                 <span className="ms-2">Profile</span>
                              </Link>
                              <Link to="/app-change-password" className="dropdown-item ai-icon">
                                 <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="text-success"
                                    width={18}
                                    height={18}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                 >
                                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                                    <polyline points="22,6 12,13 2,6" />
                                 </svg>
                                 <span className="ms-2">Change Password</span>
                              </Link>
                              <LogoutLink />
                           </Dropdown.Menu>
                        </Dropdown>
                     </ul>
                  )}

               </div>
            </nav>
         </div>
      </div>
   );
};

const mapStateToProps = (state) => ({
   user: state.auth?.userDetails,
});

export default connect(mapStateToProps)(Header);